/**
 *  Composable for app-wide utility functions.
 *
 */
export function useAppUtils() {
  const formatUrlParams = (params) => {
    const flatParams = {};

    Object.entries(params).forEach(([key, value]) => {
      if (value != null) {
        if (typeof value === 'object' && !Array.isArray(value)) {
          // Flatten nested objects
          Object.assign(flatParams, value);
        } else {
          flatParams[key] = value;
        }
      }
    });

    return new URLSearchParams(flatParams).toString();
  };

  return {
    formatUrlParams,
  };
}
